/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetaccountdetailsAccountDetail
 */
export interface JumboGetaccountdetailsAccountDetail {
    /**
     * 
     * @type {string}
     * @memberof JumboGetaccountdetailsAccountDetail
     */
    createdAt?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetaccountdetailsAccountDetail
     */
    tokenID?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboGetaccountdetailsAccountDetail
     */
    workspaceID?: string;
}

/**
 * Check if a given object implements the JumboGetaccountdetailsAccountDetail interface.
 */
export function instanceOfJumboGetaccountdetailsAccountDetail(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetaccountdetailsAccountDetailFromJSON(json: any): JumboGetaccountdetailsAccountDetail {
    return JumboGetaccountdetailsAccountDetailFromJSONTyped(json, false);
}

export function JumboGetaccountdetailsAccountDetailFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetaccountdetailsAccountDetail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'tokenID': !exists(json, 'tokenID') ? undefined : json['tokenID'],
        'workspaceID': !exists(json, 'workspaceID') ? undefined : json['workspaceID'],
    };
}

export function JumboGetaccountdetailsAccountDetailToJSON(value?: JumboGetaccountdetailsAccountDetail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'tokenID': value.tokenID,
        'workspaceID': value.workspaceID,
    };
}

